export const API_FILE_ROUTE = '/api/file';
export const API_FILES_ROUTE = '/api/files';
export const API_FILE_DOWNLOAD_URL_ROUTE = '/api/file/download';
